import { Box, type BoxRef, Pressable, Text } from '../../../../../../mads';

import { colors } from '@indeed/ifl-tokens/react-native';
import React, { forwardRef } from 'react';
import { StyleSheet } from 'react-native';

export interface ShareMenuRowProps {
    label: string;
    icon: React.ReactNode;
    onActivate: () => void;
    testID: string;
}

type RowState = { pressed: boolean; hovered?: boolean; focused?: boolean };

const buildRowStyle = (state: RowState) => [
    styles.row,
    state.hovered && styles.rowHover,
    state.focused && styles.rowFocus,
    state.pressed && styles.rowPressed,
];

export const ShareMenuRow = forwardRef<BoxRef, ShareMenuRowProps>(function ShareMenuRow(
    { label, icon, onActivate, testID },
    ref,
) {
    return (
        <Pressable
            ref={ref}
            onPress={onActivate}
            accessibilityRole="menuitem"
            accessibilityLabel={label}
            testID={testID}
            sx={buildRowStyle}
        >
            <Box sx={styles.icon}>{icon}</Box>
            <Text level={3} sx={styles.label}>
                {label}
            </Text>
        </Pressable>
    );
});

const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: 16,
        paddingVertical: 10,
        backgroundColor: colors.background,
    },
    rowHover: {
        backgroundColor: colors.backgroundActionWeakHover,
    },
    rowFocus: {
        backgroundColor: colors.backgroundActionWeakHover,
        outlineStyle: 'solid',
        outlineColor: colors.utilityFocus,
        outlineWidth: 2,
        outlineOffset: -2,
    },
    rowPressed: {
        backgroundColor: colors.backgroundActionWeakActive,
    },
    icon: {
        marginRight: 12,
    },
    label: {
        color: colors.foregroundStrong,
        flex: 1,
    },
});
